<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'studentCourseEqualization_approvalTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="data-value" *ngFor="let n of decisions">
            <label>
                <span class="decision-bubble"
                      [class.bg-danger]="n.decision.Code == 'Fail'"
                      [class.bg-success]="n.decision.Code == 'PassFull'"
                      [class.bg-warning]="n.decision.Code == 'PassPartial'"></span>
                {{n.decision.Value}}
            </label>
            <ul class="decision-courses">
                <li *ngFor="let d of n.details">
                    <div>
                        {{d.course}}
                        <span class="text-mute text-nowrap" *ngIf="d.ects">[ {{d.ects}} ]</span>
                    </div>
                    <div class="text-sub" *ngIf="d.comments">{{d.comments}}</div>
                </li>
            </ul>
        </div>
    </form>

    <app-alert level="warning">
        <div [innerHTML]="protocolWarning | safeHtml" (click)="downloadProtocol($event)"></div>
    </app-alert>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()">{{'dialog_cancel' | translate}}</button>
    <button class="btn btn-primary" type="button" (click)="ok()" [disabled]="!form.valid">{{'dialog_ok' | translate}}</button>
</div>
